import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../api/api";
import { toast } from "react-toastify";
import "../../App.css"; // ✅ Same CSS
import logo from "../../images/SPFLLOGO.png"; // adjust path if needed
import Attachments from "../../UserControls/Attachments/Attachments";
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

const CalibrationLogListPage = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]); // ✅ For search results
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState("table");
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Search term
  const navigate = useNavigate();
  const location = useLocation();
  const userName = sessionStorage.getItem("userName");

  // ✅ Fetch Calibration Logs
  const fetchLogs = async () => {
    setLoading(true);
    try {
      
      const response = await api.AssetCalibrationLogListAPI(userName);
      const data = response?.Table || [];
      setLogs(data);
      setFilteredLogs(data); // ✅ Keep copy for filtering
    } catch (error) {
      console.error("Error fetching calibration logs:", error);
      toast.error("Failed to fetch calibration logs.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  useEffect(() => {
    fetchLogs();
  }, [location]);

  const toggleView = () => {
    setViewMode((prev) => (prev === "table" ? "card" : "table"));
  };

  const handleEdit = async (logId) => {
    try {
      
      const response = await api.EditAssetCalibrationLogAPI(logId, userName);
      const editData =
        response?.EditAssetCalibrationLogAPIjs?.Table?.[0] ||
        response?.Table?.[0];

      if (editData) {
        navigate("/CalibrationLog", { state: { editData } });
      } else {
        toast.error("No data found for this record.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load edit data.");
    }
  };

  // ✅ Search Filter Logic
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    if (!term) {
      setFilteredLogs(logs);
      return;
    }
     
    const filtered = logs.filter(
      (log) =>
        (log.AssetNo && log.AssetNo.toLowerCase().includes(term)) ||
         (log.AssetName && log.AssetName.toLowerCase().includes(term)) ||
        (log.Vname && log.Vname.toLowerCase().includes(term)) ||
        (log.CertificateNumber &&
          log.CertificateNumber.toLowerCase().includes(term)) ||
        (log.Result && log.Result.toLowerCase().includes(term)) ||
        (log.Comments && log.Comments.toLowerCase().includes(term)) ||
        (log.SerInvNo && log.SerInvNo.toLowerCase().includes(term))
    );
    setFilteredLogs(filtered);
  }, [searchTerm, logs]);
const companyName = sessionStorage.getItem("companyName");
 
  return (
    <div className="asset-container">
      
<td colSpan="2" style={{ display: "flex", alignItems: "center" ,  justifyContent: "flex-end", paddingRight: "800px", }}>
  {/* <img
    src={logo}
    alt="Company Logo"
    style={{
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      backgroundColor: "white",
      boxShadow: "0 0 4px rgba(0,0,0,0.2)",
      padding: "10px",
      marginRight: "10px", // spacing between logo and text
      //objectFit: "contain",
    }}
  /> */}
  <h1
    style={{
      fontSize: "22px",
      fontWeight: "bold",
      color: "#333",
      margin: 0,
      textAlign: "left",
    }}
  >
    {companyName}
  </h1>
</td>
      <h2 className="page-title">📋 Calibration Log List</h2>

      {/* 🔹 Top Controls */}
      <div className="top-controls">
        <button
          className="btn-primary"
          onClick={() => navigate("/CalibrationLog")}
        >
          ➕ New
        </button>

        {/* ✅ Search Box */}
        <input
          type="text"
          placeholder="🔍 Search by Name, Certificate, Result..."
          className="search-box"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

    <ExcelExport data={filteredLogs} fileName="CalibrationLogList" />
    
        <div className="top-right-controls">
          <div className="view-icons">
            <button
              onClick={() => setViewMode("card")}
              className={`icon-btn ${viewMode === "card" ? "active" : ""}`}
              title="Card View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
              </svg>
            </button>

            <button
              onClick={() => setViewMode("table")}
              className={`icon-btn ${viewMode === "table" ? "active" : ""}`}
              title="Table View"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4 6h16v2H4V6zm0 4h16v2H4v-2zm0 4h16v2H4v-2zm0 4h16v2H4v-2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* 🔹 Loader / Empty */}
      {loading ? (
        <p className="mt-4 text-center text-gray-500">Loading...</p>
      ) : filteredLogs.length === 0 ? (
        <p className="mt-4 text-center text-gray-500">
          No Calibration Logs Found.
        </p>
      ) : viewMode === "card" ? (
        // 🔹 Card View
        <div className="grid-cards">
          {filteredLogs.map((log) => (
            <div key={log.LogId} className="asset-card">
              
                 <p>
                <strong>AssetNo:</strong> {log.AssetNo || "-"}
              </p>  
                 <p>
                <strong>AssetName:</strong> {log.AssetName || "-"}
              </p>
              <p>
                <strong>Calibration Date:</strong>{" "}
                {log.CalibrationDate
                  ? new Date(log.CalibrationDate).toLocaleDateString()
                  : "-"}
              </p>
              <p>
                <strong>Next Due Date:</strong>{" "}
                {log.NewNextDueDate
                  ? new Date(log.NewNextDueDate).toLocaleDateString()
                  : "-"}
              </p>
              <p>
                <strong>Certificate Number:</strong>{" "}
                {log.CertificateNumber || "-"}
              </p>
              <p>
                <strong>Result:</strong> {log.Result || "-"}
              </p>
              <p>
                <strong>Comments:</strong> {log.Comments || "-"}
              </p>
              <p>
                <strong>Invoice:</strong> {log.SerInvNo || "-"}
              </p>
              <p>
                <strong>DocNo:</strong> {log.DocNo || "-"}
              </p>
              <button
                className="btn-edit"
                onClick={() => handleEdit(log.LogId)}
              >
                ✏️ Edit
              </button>

                           {/* <Attachments
                                mdlId="CalibrationLog"
                                primeId={log?.LogId || 0}
                                primeName={log?.LogId?.toString() || ""}
                                uploadedBy={sessionStorage.getItem("userName")}
                              /> */}
                              
            </div>
          ))}
        </div>
      ) : (
        // 🔹 Table View
        <div className="table-wrapper">
          <table className="asset-table">
            <thead>
              <tr>
                <th>AssetNo</th>  
                <th>AssetName</th>
                <th>Calibration Date</th>
                <th>Next Due Date</th>
                <th>Certificate Number</th>
                <th>Result</th>
                <th>Comments</th>
                <th>SerInvNo</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log) => (
                <tr key={log.LogId}>
                   <td>{log.AssetNo || "-"}</td>
                 <td>{log.AssetName || "-"}</td>
                  <td>
                    {log.CalibrationDate
                      ? new Date(log.CalibrationDate).toLocaleDateString()
                      : "-"}
                  </td>
                  <td>
                    {log.NewNextDueDate
                      ? new Date(log.NewNextDueDate).toLocaleDateString()
                      : "-"}
                  </td>
                  <td>{log.CertificateNumber || "-"}</td>
                  <td>{log.Result || "-"}</td>
                  <td>{log.Comments || "-"}</td>
                  <td>{log.SerInvNo || "-"}</td>
                  <td>
                    <button
                      className="btn-edit-small"
                      onClick={() => handleEdit(log.LogId)}
                    >
                      ✏️ Edit
                    </button>

                       {/* <Attachments
                                mdlId="CalibrationLog"
                                primeId={log?.LogId || 0}
                                primeName={log?.LogId?.toString() || ""}
                                uploadedBy={sessionStorage.getItem("userName")}
                              /> */}
                         
                            
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CalibrationLogListPage;


 